<template>
  <div id="order">
    <!-- <div style="opacity: 0.1; background-color: #fff; z-index: 10010; position: absolute">
      <button style="width: 100px" @mouseup="orderType = 'A'">A</button>
      <button style="width: 100px" @mouseup="orderType = 'B'">B</button>
      <button style="width: 100px" @mouseup="orderType = 'C'">C</button>
      <button style="width: 100px" @mouseup="orderType = 'D'">D</button>
      <button style="width: 100px" @mouseup="orderType = 'E'">E</button>
      <button style="width: 100px" @mouseup="orderType = 'F'">F</button>
      <button
        style="width: 100px"
        @mouseup="
          orderType = 'S';
          $store.dispatch('setOrderType', 'S');
        "
      >
        sco
      </button>
    </div> -->
    <OrderC v-if="orderType == 'C'" />
    <OrderA v-if="orderType == 'A'" />
    <OrderB v-if="orderType == 'B'" />
    <OrderD v-if="orderType == 'D'" />
    <OrderE v-if="orderType == 'E'" />
    <OrderF v-if="orderType == 'F'" />
    <Sco v-if="orderType == 'S'" ref="scoComponent" />
  </div>
</template>
<script>
import orderC from '@/template/order/Order_C.vue';
import orderA from '@/template/order/Order_A.vue';
import orderB from '@/template/order/Order_B.vue';
import orderD from '@/template/order/Order_D.vue';
import orderE from '@/template/order/Order_E.vue';
import orderF from '@/template/order/Order_F.vue';
import sco from '@/template/sco/Sco.vue';
import {ref} from 'vue';

export default {
  name: 'order',

  beforeMount() {},
  mounted() {
    if (this.$store.getters.getSettingType == '3') this.orderType = 'S';
    this.$logInfo(`Enter ORDER page type : ${this.orderType}`);
  },
  unmounted() {},
  data() {
    return {
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
    };
  },
  components: {
    OrderC: orderC,
    OrderA: orderA,
    OrderB: orderB,
    OrderD: orderD,
    OrderE: orderE,
    OrderF: orderF,
    Sco: sco,
  },
  methods: {
    getItemDetail(barcode) {
      this.$refs.scoComponent.getItemDetail(barcode);
    },
  },
  computed: {},
  watch: {},
  updated() {},
};
</script>
<style scoped>
.scheduleArea img,
.scheduleArea video {
  width: 100%;
  height: 100%;
}
</style>
